import {
    DOCUMENT
} from '@angular/common';
import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    Input,
    ElementRef,
    Inject,
    Output,
    EventEmitter,
    ChangeDetectorRef
} from '@angular/core';
import {
    KtdGridComponent,
    KtdGridLayout,
    KtdResizeEnd,
    ktdTrackById
} from '@katoid/angular-grid-layout';
import {
    StateService,
    IDashboardViewState,
    DiscovererQueryService,
    DashboardController,
    IDashboardReportConfig,
    DashboardFiltersService,
    ChartRoutingService,
    ReportPersistService,
    IChartState,
    ChartConfig,
    ChartFilter,
    IDynamicReport
} from '@discoverer/core/services';
import {
    Router
} from '@angular/router';
import { DiscoReportContext } from '../disco-report/disco-report.component';
import { DialogsManagerService } from '@discoverer/dynamic-reports/dialogs';
import { take } from 'rxjs/operators';


@Component({
    selector: 'dashboard-view',
    templateUrl: './dashboard-view.component.html',
    styleUrls: ['./dashboard-view.component.scss']
})
export class DashboardViewComponent extends DashboardController implements OnDestroy {
    @Input() public dashboardViewState: StateService<IDashboardViewState>;
    @Input() public queryService: DiscovererQueryService;
    @Input() public app: string;
    public disableEdit: boolean;
    _editMode = false
    @Input() public set editMode(isEditMode: boolean) {
        this.disableDrag = this.disableResize = this.disableRemove = this.disableEdit = !isEditMode;
        this._editMode  = isEditMode;
    }
    get editMode() {
        return this._editMode;
    }
    @Input() set selectedReports(value: IDashboardReportConfig[]) {
        this.mapReportsToLayout(value);
        this._selectedReports = value;
    }
    get selectedReports(): IDashboardReportConfig[] {
        return this._selectedReports;
    }
    @Input() dashboardFiltersService: DashboardFiltersService;

    @Output() public onResize: EventEmitter<KtdResizeEnd> = new EventEmitter<KtdResizeEnd>();
    @Output() public onRemove: EventEmitter<string> = new EventEmitter<string>();
    @ViewChild(KtdGridComponent, { static: true }) grid: KtdGridComponent;
    private _selectedReports: IDashboardReportConfig[];
    trackById = ktdTrackById;
    contextCollection: DiscoReportContext[] = [];
    layouts: KtdGridLayout = [];

    constructor(
        @Inject(DOCUMENT) public document: Document,
        public elementRef: ElementRef,
        private router: Router,
        private _cdr: ChangeDetectorRef,
        private _dialogsManagerService: DialogsManagerService,
        private _chartRoutingService: ChartRoutingService,

    ) {
        super(elementRef, document);
    }


    public mapReportsToLayout(dashboards: IDashboardReportConfig[]) {
        this.layout = [];
        dashboards.forEach(val => {
            if (!this.layout.includes(val)) {
                this.layout.push(val)
            }
        });
    }

    public async openReport(reportId: string, tabId: string) {
        const currentContext = this.contextCollection[reportId] as DiscoReportContext;
        const reportPersistService = currentContext.reportPersistService as ReportPersistService;
        const mainReq = await reportPersistService.getRequest(reportId);
        const req: IDynamicReport = await reportPersistService.oLastRequestData.pipe(take(1)).toPromise();
        const state = await reportPersistService.chartState.oState.pipe(take(1)).toPromise() as IChartState;
        const chartConfig = state.chartConfig?.categories;

        await this._chartRoutingService.openSelectedRecords(reportPersistService, this.app, tabId, { categoriesFilter: null, seriesFilters: [] }, req, req.mainView.type, chartConfig as any, true)
    }
    public async edit(reportId: string, tabId: string) {
        const x = await this._dialogsManagerService.openNewReportDialog(tabId, reportId).toPromise()
        this.contextCollection[reportId]?.reportPersistService?.resetRequest();
        this._cdr.detectChanges()
    }
    public addNewReport(report: IDashboardReportConfig) {
        this.selectedReports.push(report);
    }
    public onDragEnded(event: KtdResizeEnd) {
        this.isDragging = false;
        this.onResize.emit(event);
    }
    public onResizeEnded(event: KtdResizeEnd) {
        this.isResizing = false;
        this.onResize.emit(event);
    }

    public removeItem(reportId: string): void {
        this.onRemove.emit(reportId);
        delete this.contextCollection[reportId];
    }
    public isMissingReport(context: DiscoReportContext) {
        return context?.reportPersistService?.isMissingReport
    }
}

